import { request, METHOD } from '@/utils/request'
import Cookie from 'js-cookie'


export async function queryOrganList(input) {
  return request(`/organ/queryOrganList`, METHOD.POST, input)
}

export async function eidtOrganNode(inputType) {
  return request(`/organ/updateOrgan`, METHOD.POST, inputType)
}


export async function addOrganNode(inputType) {
  return request(`/organ/addOrganNode`, METHOD.POST, inputType)
}

export async function getBasicSysMenu() {
  return request(`/organ/getBasicSysMenu`, METHOD.POST)
}

export async function getOptionSysMenu(val) {
  return request(`/organ/getOptionSysMenu`, METHOD.POST, { type: val })
}

export async function addGwSysMenu(data) {
  return request(`/organ/addGwSysMenu`, METHOD.POST, data)
}

export async function initGwTable(data) {
  return request(`/organ/initGwTable`, METHOD.POST, data)
}

export async function getEditViewMenu(data) {
  return request(`/organ/getEditViewMenu`, METHOD.POST, data)
}

export async function editGwSysMenu(data) {
  return request(`/organ/editGwSysMenu`, METHOD.POST, data)
}

export async function deleteGw(data) {
  return request(`/organ/deleteGw`, METHOD.POST, data)
}
// ------------------------人员
export async function initPerTable(data) {
  return request(`/organ/initPerTable`, METHOD.POST, data)
}

export async function getPerson(data) {
  return request(`/organ/getPerson`, METHOD.POST, data)
}

export async function getSelcetOrganGw(data) {
  return request(`/organ/getSelcetOrganGw`, METHOD.POST, data)
}

export async function addPersonGw(data) {
  return request(`/organ/addPersonGw`, METHOD.POST, data)
}

export async function deletePersonGw(data) {
  return request(`/organ/deletePersonGw`, METHOD.POST, data)
}

export async function deletePersonGwSelect(data) {
  return request(`/organ/deletePersonGwSelect`, METHOD.POST, data)
}

export async function getGwByOrganId(data) {
  return request(`/organ/getGwByOrganid`, METHOD.POST, data)
}

export async function changeGw(data) {
  return request(`/organ/changeGw`, METHOD.POST, data)
}

export async function getPositionTree(organId) {
  return request(`/organ/getPositionTree`, METHOD.POST, { organId: organId })
}

export async function getTotalPerson(data) {
  return request(`/organ/getTotalPerson`, METHOD.POST, data)
}

export async function changeSort(data) {
  return request(`/organ/changeSort`, METHOD.POST, data)
}

export async function exportPersonnel(data) {
  const token = Cookie.get('Authorization') || '';
  
  const response = await fetch('/api/organ/exportPersonnel', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token
    },
    body: JSON.stringify(data)
  });

  if (response.ok) {
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.indexOf('application/json') !== -1) {
      const json = await response.json();
      throw new Error(json.message || '导出失败');
    }
    return response.blob();
  } else {
    throw new Error('File export failed');
  }
}

export async function getManageOrganList(postId, organId) {
  return request(`/organ/getManageOrganList?postId=${postId}&organId=${organId}`, METHOD.POST)
}

export async function saveManageOrganList(data) {
  return request(`/organ/saveManageOrganList`, METHOD.POST, data)
}

export async function checkManagePermission(organId,type) {
  return request(`/organ/checkManagePermission?organId=${organId}&type=${type}`, METHOD.POST)
}

// 群组相关API
export async function getGroupList(organId, organType, groupName, pageCurrent, pageSize) {
  return request(`/group/getGroupList?organId=${organId}&organType=${organType}&groupName=${groupName}&pageCurrent=${pageCurrent}&pageSize=${pageSize}`, METHOD.POST)
}

export async function getGroupMembers(groupId, organId) {
  return request(`/group/getGroupMembers?groupId=${groupId}&organId=${organId}`, METHOD.POST)
}

export async function addGroup(groupInfo) {
  return request(`/group/addGroup`, METHOD.POST, groupInfo)
}

export async function updateGroup(groupInfo) {
  return request(`/group/updateGroup`, METHOD.POST, groupInfo)
}

export async function deleteGroup(groupId) {
  return request(`/group/deleteGroup?groupId=${groupId}`, METHOD.POST)
}

export async function checkGroupPermission(groupId) {
  return request(`/group/checkGroupPermission?groupId=${groupId}`, METHOD.POST)
}

// 导入人员
export async function importPersonnel(formData) {
  const token = Cookie.get('Authorization') || '';
  
  return fetch('/api/organ/importPersonnel', {
    method: 'POST',
    headers: {
      'Authorization': token
    },
    body: formData
  }).then(response => response.json());
}